import React, { useCallback, useEffect, useState } from 'react';

import * as initStorage from '../lib/storage/init';

type Init = initStorage.Init;

type InitContextProps = {
  // Init defines the user's init
  init: Init | null;
  // setInit sets a new init in context and stores it in local storage
  setInit: (init: Init) => void;
  // removeInit removes the init from context and local storage
  removeInit: () => void;
};

const InitContext = React.createContext<InitContextProps | null>(null);

/**
 * InitContextProvider provides the init context to it's children
 */
export function InitContextProvider({ children }: React.PropsWithChildren<{}>) {
  const [init, setInitState] = useState(initStorage.get());

  // Persist the token to local storage when the token changes. Remove the token
  // if it is null.
  useEffect(() => {
    if (init) {
      initStorage.set(init);
    } else {
      initStorage.remove();
    }
  }, [init]);

  const removeInit = useCallback(() => {
    setInitState(null);
  }, []);

  const setInit = useCallback((s) => {
    setInitState(s);
  }, []);

  const ctx = {
    init,
    setInit,
    removeInit,
  };

  return <InitContext.Provider value={ctx}>{children}</InitContext.Provider>;
}

export default InitContext;
